import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { PortalLoginView } from './PortalLoginView.js';
import { PortalDashboard } from './PortalDashboard.js';

export const PortalLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-900 font-sans text-slate-800 flex items-center justify-center sm:p-4">
      {/* Mobile Frame Container */}
      <div className="w-full h-full sm:w-[400px] sm:h-[800px] bg-white sm:rounded-[40px] sm:shadow-2xl sm:border-[8px] sm:border-slate-800 overflow-hidden relative flex flex-col">
        {/* iOS style notch/status bar area for desktop preview */}
        <div className="hidden sm:flex h-7 w-full bg-slate-900 absolute top-0 z-50 rounded-t-[32px] items-center justify-center">
          <div className="w-32 h-5 bg-black rounded-b-xl"></div>
        </div>

        {/* Content Area */}
        <div className="flex-1 w-full h-full overflow-y-auto sm:pt-7 scrollbar-hide bg-slate-50 relative">
          <Routes>
            <Route path="login" element={<PortalLoginView />} />
            <Route path="dashboard" element={<PortalDashboard />} />
            <Route path="*" element={<Navigate to="login" replace />} />
            <Route index element={<Navigate to="login" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};
